module.exports = __webpack_public_path__ + "img/gift-card-generic-alt.18be7ba6.svg";